import React from 'react';

const PdfAnchor = () => {
  const anchorName = 'anchor-' + Math.round(Math.random()*1000000);
  const AnchorElement = () => <a 
    name={anchorName} 
    id={anchorName} 
    style={{display: 'inline-block', width: 0, height: 0, opacity: 0}}
  />
  return [AnchorElement, anchorName]
}

export default PdfAnchor;